const lan = {
  es: {
    "back":"Volver Atras",
    "language": "es",
    "verify":"Verificacion",
    "security":"Seguridad",
    "type": "Tipo",
    "single": "Individual",
    "picks": "Apuestas",
    "loading": "Cargando...",
    "multiple": "Multiple",
    "totalStake": "Apuesta Total",
    "multiAlert": "Apuestas del mismo evento no pueden combinarse",
    "soccer": "Futbol",
    "clean": "Limpiar",
    "fav": "Populares",
    "moreLeagues": "Mas Ligas",
    "search": "Buscar por liga o equipo",
    "date": "Fecha",
    "deposit": "Recarga",
    "promoHeader": "Mas promociones",
    "promoTitle": "Visita nuestra seccion de promociones",
    "promoText": "Siguenos en las redes sociales para estar al tanto de promociones exclusivas de LogoBet",
    "forgetPass": "Olvido su contraseña?",
    "marketing": "Estoy de acuerdo en recibir emails",
    "bonoHeader": "Bienvenido",
    "bonoText": "Recibe bonos de bienvenida en tu primera recarga",
    "bonoTitle": "Hasta 25% en bonos de bienvenida",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "confirm": " Confirmo que tengo al menos 18 años y acepto",
    "terms": "Los Terminos y Condiciones",
    "later": "Luego",
    "lan": "Idioma",
    "format": "Formato",
    "alreadyRegister": "Ya tiene cuenta?",
    "next": "Proximos Eventos",
    "balance": "Saldo",
    "pass": "Contraseña",
    "user": "Usuario",
    "username":"Nombre de Usuario",
    "birthday":"Fecha de Nacimiento",
    "login": "Iniciar Sesion",
    "Serial":"Serial",
    "register": "Registrarse",
    "profile": "Mi Perfil",
    "logout": "Salir",
    "bets": "Apuestas",
    "coupon": "Cupon",
    "stake": "Apuesta",
    "price": "Cuota",
    "win": "Ganancias",
    "send": "Realizar Apuesta",
    "save":"Guardar",
    "lines": "Movimientos",
    "currentpass":"Contraseña Actual",
    "repeatpass":"Repetir Contraseña",
    "newpass":"Nueva Contraseña",
    "email": "Correo Electronico",
    "phone": "Telefono",
    "fullname": "Nombre Completo",
    "address": "Direccion",
    "country": "Pais",
    "userdata": "Datos personales",
    "warning": "Atencion!",
    "error": "Ticket no permitido",
    "success": "Operacion Exitosa!",
    "select": "Coloque su apuesta",
    "errormsj": "Ops, ha ocurrido un error, intente de nuevo",
    "selectstake": "Coloque su apuesta",
    "ok": "Esta seguro?",
    "successmsj": "Ticket Aceptado",
    "print": "Imprimir",
    "printmsj": "Desea imprimir este cupon?",
    "myBets": "Mis Apuestas",
    "yes": "Si",
    "no": "No",
    "cancel": "Operacion Cancelada",
    "cancelmsj": "No se enviaron datos",

    "draw": "Empate",
    "over": "Mas",
    "under": "Menos",
    "odd": "Impar",
    "even": "Par",

    "sheduled": "Programado",

    "Over&Under Full Time": "Mas o Menos Tiempo Completo",
    "Odd or Even Full Time": "Par / Impar Tiempo Completo",
    "Both Teams to Score Full Time": "Ambos Equipos Marcan TC",
    "Double Chance Full Time": "Doble Chance TC",
    "Draw No Bet Full Time": "Empate no Apuesta TC",

    "1X2 Full Time": "Ganador del Encuentro",
    "1X2 1st Half": "1X2 1º tiempo",
    "1X2 2nd Half": "1X2 2º tiempo",
    "1X2 1st Period": "1X2 1º Periodo",
    "1X2 2nd Period": "1X2 2º Periodo",
    "1X2 3rd Period": "1X2 3º Periodo",
    "1X2 1Q": "1X2 1Q",
    "1X2 2Q": "1X2 2Q",
    "Over&Under FT including OT": "Mas o Menos Tiempo Completo + Extra",
    "Odd or Even FT including OT": "Par o Impar Tiempo Completo + Extra",
    "Home Away FT including OT": "Local o Visitante Tiempo Completo + Extra",
    "Over&Under 1st Half": "Mas o Menos 1º Tiempo",
    "Over&Under 2nd Half": "Mas o Menos 2º Tiempo",
    "Over&Under 1st Period": "Mas o Menos 1º Periodo",
    "Over&Under 2nd Period": "Mas o Menos 2º Periodo",
    "Over&Under 3rd Period": "Mas o Menos 3º Periodo",
    "Over&Under 1Q": "Mas o Menos 1Q",
    "Over&Under 2Q": "Mas o Menos 2Q",


    "1X2 3Q": "1X2 3Q",
    "1X2 4Q": "1X2 4T",
    "1X2 1st Inning": "1X2 1ª entrada",
    "1X2 2nd Inning": "1X2 2ª entrada",
    "1X2 3rd Inning": "1X2 3ª entrada",
    "1X2 4th Inning": "1X2 4o entrada",
    "1X2 5th Inning": "1X2 5ª entrada",
    "1X2 6th Inning": "1X2 6º entrada",
    "1X2 7th Inning": "1X2 7ª entrada",
    "1X2 8th Inning": "1X2 8ª entrada",
    "1X2 9th Inning": "1X2 9º entrada",
    "Over&Under 3Q": "Mas o Menos 3Q",
    "Over&Under 4Q": "Mas o Menos 4Q",


    "Odd or Even 3Q": "Par / Impar 3Q",
    "Odd or Even 4Q": "Par / Impar 4Q",
    "Odd or Even 1st Set": "Par / Impar 1Set",
    "Odd or Even 2nd Set": "Par / Impar 2Set",
    "Odd or Even 3rd Set": "Par / Impar 3Set",
    "Odd or Even 1st Inning": "Par / Impar 1Inn",
    "Odd or Even 2nd Inning": "Par / Impar 2Inn",
    "Odd or Even 3rd Inning": "Par / Impar 3Inn",
    "Odd or Even 4th Inning": "Par / Impar 4Inn",
    "Odd or Even 5th Inning": "Par / Impar 5Inn",
    "Odd or Even 6th Inning": "Par / Impar 6Inn",
    "Odd or Even 7th Inning": "Par / Impar 7Inn",
    "Odd or Even 8th Inning": "Par / Impar 8Inn",
    "Odd or Even 9th Inning": "Par / Impar 9Inn",
    "amount": "Monto",
    "status": "Estado",
    "withdraw": "Retiro",
    "welcome": "Bienvenido de nuevo",
    "adjustment": "Ajuste",
    "nologin": "Usuario o contraseña invalido",
    "yes score": "Si Anotan",
    "no score": "No Anotan",
    "1&NG": "Local + No Anotan",
    "X&NG": "Empate + No Anotan",
    "2&NG": "Visitante + No Anotan",
    "1X2 & NG": "1X2 + No Anotan",
    "1X2 & GG": "1X2 + Si Anotan",
    "exact": "Exactamente",
    "between": "Entre",
    "done": "Completado",

    "Espera": "Espera",
    "En Espera": "En Espera",
    "Gano": "Gano",
    "Perdio": "Perdio",
    "Anulado": "Anulado",
    "Sin Efecto": "Sin Efecto",
    "Error BD": "Error BD",
    "Sin Efecto (Pagado)": "Sin Efecto (Cargado)",
    "Gano (Pagado)": "Gano (Cargado)",
    "basketball":"Balocesto",
    "hockey":"Hockey",
    "Reservado": "Reservado",
    
  },
  en: {
    "back":"Go Back",
    "hockey":"Hockey",
    "nologin": "Username or password invalid",
    "verify":"Verification",
    "security":"Security",
    "done": "Complete",
    "exact": "Exactly",
    "Espera": "Waiting",
    "En Espera": "Waiting",
    "Gano": "Winner",
    "Perdio": "Lost",
    "Anulado": "Cancelled",
    "Sin Efecto": "Bonus",
    "Error BD": "Error BD",
    "Sin Efecto (Pagado)": "Bonus (Loaded)",
    "Gano (Pagado)": "Winner (Loaded)",
    "Reservado": "Reserved",
    "between": "Between",
    "1&NG": "Home + No goal",
    "X&NG": "Draw + No goal",
    "2&NG": "Away + No goal",
    "1X2 & NG": "1X2 + No Goals",
    "1X2 & GG": "1X2 + Goals",
    "yes score": "Yes score",
    "Serial":"Serial",
    "no score": "No score",
    "language": "en",
    "withdraw": "Retiro",
    "welcome": "Welcome back",
    "adjustment": "Ajuste",
    "status": "Status",
    "type": "Type",
    "amount": "Amount",
    "soccer": "Soccer",
    "single": "Straight",
    "picks": "Picks",
    "loading": "Loading...",
    "multiple": "Parlay",
    "totalStake": "Total Stake",
    "multiAlert": "Bets from the same event cannot be combined",
    "clean": "Clear",
    "fav": "Trending",
    "moreLeagues": "More Leagues",
    "search": "Search leagues or competitors",
    "date": "Date",
    "deposit": "Deposit",
    "promoHeader": "More Gift",
    "promoTitle": "Check our gift section",
    "promoText": "Follow us on social network for more exclusive gift from LogoBet",
    "forgetPass": "Did you forget your password?",
    "marketing": "Estoy de acuerdo en recibir emails",
    "bonoHeader": "Welcome",
    "bonoText": "25% Welcome bonus!",
    "bonoTitle": "Welcome bonus in first deposits",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "confirm": "Confirmo que tengo al menos 18 años y acepto",
    "terms": "Los Terminos y Condiciones",
    "later": "Later",
    "lan": "Language",
    "format": "Format",
    "alreadyRegister": "Already register?",
    "next": "Next Matches",
    "balance": "Balance",
    "pass": "Password",
    "user": "User",
    "username":"Username",
    "birthday":"BirthDay",
    "login": "Login",
    "register": "Register",
    "profile": "My Profile",
    "logout": "Logout",
    "coupon": "BetSlip",
    "bets": "Bets",
    "myBets": "My Bets",
    "stake": "Stake",
    "price": "Price",
    "win": "Total Win",
    "send": "Confirm",
    "save":"Save",
    "lines": "Report",
    "currentpass":"Current Password",
    "repeatpass":"Repeat Password",
    "newpass":"New Password",
    "email": "Email",
    "phone": "Phone",
    "fullname": "Full name",
    "address": "Address",
    "country": "Country",
    "userdata": "User Info",
    "warning": "Warning!",
    "error": "Not Allowed",
    "success": "Well done!",
    "select": "Select a match",
    "errormsj": "Ops, something happen, try again!",
    "selectstake": "Place your stake",
    "ok": "Are you sure?",
    "successmsj": "Ticket Accepted",
    "print": "Print",
    "printmsj": "Are you wanna print?",
    "yes": "Yes",
    "no": "No",
    "cancel": "Cancelled",
    "cancelmsj": "No data wasnt send",
    "draw": "Draw",
    "over": "Over",
    "under": "Under",
    "sheduled": "Sheduled",
    "Over&Under Full Time": "Over&Under Full Time",
    "Odd or Even Full Time": "Odd or Even Full Time",
    "Both Teams to Score Full Time": "Both Teams to Score Full Time",
    "Double Chance Full Time": "Double Chance Full Time",
    "Draw No Bet Full Time": "Draw No Bet Full Time",
    "odd": "Odd",
    "even": "Even",
    "basketball":"Basketball",
  }
}
export default lan;


// WEBPACK FOOTER //
// ./src/languages.js